import React from 'react'
import './AppsFeatures.scss'
import Container from 'reactor/components/Grid/ContainerWithWidth'
import BoxItem from 'reactor/components/Box'
import GridItem from 'reactor/components/Grid/GridItem'
import Hidden from '@material-ui/core/Hidden'
import Heading from '../../../components/heading'
import Slider from "react-slick"


const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 1,
    rows: 2,
    rtl: true,
    // centerMode: true,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 425,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
    ],
};

 export default function AppsFeatures(props) {
    return(
        <BoxItem className="apps__features">
            <Container>
                <Heading title="مميزات تصميم التطبيقات لدينا" />
            </Container>
            <Container>
                <GridItem md={7}>
                    <Slider {...settings}>
                        {props.object.map( (feature, index)=>(
                            <div key={index} className="apps__features--item">
                                <div className="apps__features--item-img">
                                    <img src={feature.img} alt={feature.title} />
                                </div>
                                <div className="apps__features--item-caption">
                                    <h4>{feature.title}</h4>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </GridItem>
                <GridItem md={5} align="center" className="hidden-xs-sm">
                    <img src={props.featureImg} alt="" className="img-fluid apps__features--image" />
                </GridItem>
            </Container>
        </BoxItem>
    )
 }